import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface ClearAllButtonProps {
  onClick: () => void;
  label: string;
}

/**
 * ClearAllButton component that matches the design in the image
 * Shows an X icon followed by "Clear all" text
 */
const ClearAllButton: React.FC<ClearAllButtonProps> = ({ onClick, label }) => {
  const theme = useTheme();

  return (
    <Box 
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: 'text.secondary',
        '&:hover': {
          color: theme.palette.primary.main,
        },
      }}
    >
      <ClearIcon fontSize="small" />
      <Typography variant="body2" sx={{ ml: 0.5 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default ClearAllButton;
